import * as Tooltip from '@radix-ui/react-tooltip';
import React from 'react';
import styles from './DataSourceIcons.module.scss';

interface DataSourceIconsProps {
  sources?: string[];
  className?: string;
}

const DataSourceIcons: React.FC<DataSourceIconsProps> = ({
    sources,
    className
}) => {

    if (!sources || sources.length === 0) return null;

    const getIconUrl = (source: string) => {
        const domains: Record<string, string> = {
            shopify: 'shopify.com',
            google: 'google.com',
            facebook: 'facebook.com',
            tiktok: 'tiktok.com',
            instagram: 'instagram.com',
            amazon: 'amazon.com',
            bing: 'bing.com',
            pinterest: 'pinterest.com',
            twitter: 'twitter.com',
            youtube: 'youtube.com',
            linkedin: 'linkedin.com',
            klaviyo: 'klaviyo.com',
            mailchimp: 'mailchimp.com',
            'google ads': 'google.com',
            'google analytics': 'analytics.google.com',
            'facebook ads': 'facebook.com',
            'tiktok ads': 'tiktok.com'
        };
        const domain = domains[source.toLowerCase()] || `${source}.com`;
        return `https://cdn.brandfetch.io/${domain}`;
    };

    // 去重并限制显示最多 3 个
    const uniqueSources = [...new Set(sources)];
    const displaySources = uniqueSources.slice(0, 3);
    const tooltipText = uniqueSources
        .map(s =>
            s
                .split(' ')
                .map(w => w.charAt(0).toUpperCase() + w.slice(1))
                .join(' '))
        .join(', ');

    return (
        <Tooltip.Provider>
            <Tooltip.Root delayDuration={0}>
                <Tooltip.Trigger asChild>
                    <div className={`${styles.dataSourceIcons} ${className || ''}`}>
                        {/* 图标容器 */}
                        <div className={styles.iconsContainer}>
                            {displaySources.map((source, idx) => (
                                <div key={idx} className={styles.iconWrapper}>
                                    <img
                                        src={getIconUrl(source)}
                                        alt={source}
                                        className={styles.iconImage}
                                        onError={(e) => {
                                            const target = e.target as HTMLImageElement;
                                            target.style.display = 'none';
                                        }}
                                    />
                                </div>
                            ))}
                            {uniqueSources.length > 3 && (
                            <div className={styles.moreIcon}>
                                +
                                {' '}
                                {uniqueSources.length - 3}
                            </div>
                            )}
                        </div>
                    </div>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content className={styles.tooltipContent} sideOffset={8}>
                        {tooltipText}
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        </Tooltip.Provider>
    );
};

export default DataSourceIcons;
